import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarSquareRegularActivity from './calendar-square-regular-activity-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CalendarSquareRegularActivity {...validProps} />;
}

SvgComponent.iconName = 'calendarSquareRegularActivity';

export const CalendarSquareRegularActivityIcon = svgIconWrapper(SvgComponent);
